import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxGalleryComponent } from './phx-gallery.component';
import { PhxIconModule } from '../icon/icon.module';
import { PhxModalModule } from '../modal/phx-modal.module';
import { PhxNavigationButtonModule } from '../navigation-button/phx-navigation-button.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxDividerModule } from '../divider/phx-divider.module';
import { PhxImagePanZoomModule } from '../image-pan-zoom/phx-image-pan-zoom.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';

@NgModule({
  declarations: [PhxGalleryComponent],
  imports: [CommonModule, PhxIconModule, PhxModalModule, PhxIconButtonModule, PhxNavigationButtonModule, PhxDividerModule, PhxImagePanZoomModule, PhxTranslationsRootModule],
  exports: [PhxGalleryComponent],
})
export class PhxGalleryModule { }
